import { render, staticRenderFns } from "./RobberyPersonalPropertyCountQuestion.vue?vue&type=template&id=9267bb76&scoped=true"
import script from "./RobberyPersonalPropertyCountQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyPersonalPropertyCountQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9267bb76",
  null
  
)

export default component.exports